import { combineReducers } from 'redux-immutable'
import leaveTypeListReducer from './leave-type-list-reducer'
import leaveTypeGetReducer from './leave-type-get-reducer'
import leaveTypeCreateReducer from './leave-type-create-reducer'
import leaveTypeEditReducer from './leave-type-edit-reducer'
import leaveTypeDeleteReducer from './leave-type-delete-reducer'
import leaveTypeExportReducer from './leave-type-export-reducer'

export default combineReducers({
  leaveTypeList: leaveTypeListReducer,
  leaveTypeGet: leaveTypeGetReducer,
  leaveTypeCreate: leaveTypeCreateReducer,
  leaveTypeEdit: leaveTypeEditReducer,
  leaveTypeDelete: leaveTypeDeleteReducer,
  leaveTypeExport: leaveTypeExportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/leave-type/index.js